import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../queryKeys';

/** What GET /api/v1/system/alerts/summary returns (1.2.8): the System status alerts showing now, suppressed ones left out. */
export interface AlertSummary { errors: number; warnings: number }

/** The Admin rail badge (1.2.8), for administrators only (the endpoint needs admin). System status keeps it in step. */
export function useAlertSummary(enabled: boolean) {
  return useQuery({ queryKey: queryKeys.alertSummary(), queryFn: () => api<AlertSummary>('/api/v1/system/alerts/summary'), enabled, refetchInterval: 30_000 });
}
